module.exports = __webpack_public_path__ + "static/img/hero-4.ea61035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-4.jpg
// module id = W/JB
// module chunks = 0